import "./styles/LodingSpiner.css"
// Using direct public path for static assets
const logo = '/images/logopreview.png';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  fullscreen?: boolean;
  className?: string;
}

const LoadingSpinner = ({
  size = 'medium',
  fullscreen = false,
  className = ''
}: LoadingSpinnerProps) => {
  const sizeClass = `loading-spinner--${size}`;
  const fullscreenClass = fullscreen ? 'loading-spinner--fullscreen' : '';
  
  return (
    <div 
      className={`loading-spinner ${sizeClass} ${fullscreenClass} ${className}`}
      aria-label="Loading..."
      role="status"
    >
      <div className="loading-spinner__inner">
        <img 
          src={logo} 
          alt="Loading..." 
          className="loading-spinner__image"
        />
        <div className="loading-spinner__border"></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;